export enum PermissionEnum {
  USER__VIEW = "user-view",
  USER__DETAILS = "user-details",
  USER__EDIT = "user-edit",

  /**
   * User
   */
  ROLE__VIEW = "role-view",

  /**
   * Customer
   */
  CUSTOMER_VIEW = "customer-view",
  CUSTOMER__CREATE = "customer-create",
  CUSTOMER__EDIT = "customer-edit",

  /**
   * Supplier
   */
  SUPPLIER__VIEW = "supplier-view",
  SUPPLIER__CREATE = "supplier-create",
  SUPPLIER__EDIT = "supplier-edit",

  /**
   * Upload
   */
  UPLOAD__VIEW = "upload-view",
  UPLOAD__CREATE = "upload-create",
  UPLOAD__EDIT = "upload-edit",
  UPLOAD__ANALYTICS = "upload-analytics",

  /**
   * Offer
   */
  OFFER__VIEW = "offer-view",
  OFFER__EDIT = "offer-edit",
  OFFER__REQUEST = "offer-request",
  OFFER__DOWNLOAD = "offer-download",

  /**
   * Invite User
   */
  INVITE_USER__INVITE = "invite_user-invite",
  INVITE_USER__VIEW = "invite_user-view",

  /**
   * Offer Request
   */
  OFFER_REQUEST__VIEW = "offer_request-view",
  OFFER_REQUEST__EDIT = "offer_request-edit",

  /**
   * Contact Point
   */
  CONTACT_POINT__VIEW = "contact_point-view",
  CONTACT_POINT__EDIT = "contact_point-edit",
  CONTACT_POINT__CREATE = "contact_point-create",

  /**
   * Offer Alert
   */
  OFFER_ALERT__VIEW = "offer_alert-view",
  OFFER_ALERT__EDIT = "offer_alert-edit",
  OFFER_ALERT__CREATE = "offer_alert-create",

  /**
   * Organisation
   */
  ORGANISATION__VIEW = "organisation-view",
  ORGANISATION__DETAILS = "organisation-details",
  ORGANISATION__EDIT = "organisation-edit",

  /**
   * Organisation Plan
   */
  ORGANISATION_PLAN__EDIT = "organisation_plan-edit",

  /**
   * Organisation Settings
   */
  ORGANISATION_SETTINGS__VIEW = "organisation_settings-view",
  ORGANISATION_SETTINGS__EDIT = "organisation_settings-edit",

  /**
   * Margin
   */
  MARGIN__VIEW = "margin-view",
  MARGIN__EDIT = "margin-edit",
  MARGIN__CREATE = "margin-create",
  MARGIN__DELETE = "margin-delete",

  /**
   * Order
   */
  ORDER__VIEW = "order-view",
  ORDER__EDIT = "order-edit",
  ORDER__REQUEST = "order-request",
  ORDER__DELETE = "order-delete",

  /**
   * Contact Request Sales
   */
  CONTACT_REQUEST_SALES__VIEW = "contact_request_sales-view",
  CONTACT_REQUEST_SALES__EDIT = "contact_request_sales-edit",

  /**
   * Contact Request Support
   */
  CONTACT_REQUEST_SUPPORT__VIEW = "contact_request_support-view",
  CONTACT_REQUEST_SUPPORT__EDIT = "contact_request_support-edit",

  /**
   * General Dashboard
   */
  GENERAL_DASHBOARD__VIEW = "general_dashboard-view",

  /**
   * Integration Exact
   */
  INTEGRATION_EXACT__VIEW = "integration_exact-view",
  INTEGRATION_EXACT__EDIT = "integration_exact-edit",
  INTEGRATION_EXACT__CREATE = "integration_exact-create",
  INTEGRATION_EXACT__DELETE = "integration_exact-delete",

  /**
   * Pricing Plan
   */
  PRICING_PLAN__VIEW = "pricing_plan-view",
  PRICING_PLAN__EDIT = "pricing_plan-edit",

  /**
   * Inbound Email
   */
  INBOUND_EMAIL_VIEW = "inbound_email-view",

  /**
   * Upload B2B Market Prices
   */
  UPLOAD_B2B_MARKET_PRICES_CREATE = "upload_b2b_market_prices-create",
  UPLOAD_B2B_MARKET_PRICES_VIEW = "upload_b2b_market_prices-view",

  /**
   * Upload Vintage Score Scores
   */
  VINTAGE_SCORE_UPLOAD_CREATE = "vintage_score_upload-create",
  VINTAGE_SCORE_UPLOAD_VIEW = "vintage_score_upload-view",

  /**
   * Content
   */
  CONTENT_VIEW = "content-view",
  CONTENT_EDIT = "content-edit",

  /**
   * User Organisation Claim Requests
   */
  USER_ORGANISATION_CLAIM_REQUEST__VIEW = "user_organisation_claim_request-view",
  USER_ORGANISATION_CLAIM_REQUEST__EDIT = "user_organisation_claim_request-edit",

  /**
   * Chat
   */
  CHAT_VIEW = "chat-view",
  CHAT_CREATE = "chat-create",

  /**
   * Export
   */
  EXPORT_VIEW = "export-view",
  EXPORT_CREATE = "export-create",
}
